
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import PassengerEdit from "./PassengerEdit.vue";

@Component({
  components: {
    PassengerEdit,
  },
})
export default class PassengerListItem extends Vue {
  @Prop({ default: null }) passenger!: IPassenger;

  editPassengerDialog: boolean = false;
  dialogOpener: HTMLElement | null = null;

  @Watch("editPassengerDialog")
  editPassengerDialogChanged(newValue: boolean) {
    if (newValue) {
      this.$store.commit('app/incrementOpenDialogCount');
      this.dialogOpener = document.activeElement as HTMLElement | null;
      this.$nextTick(() => {
        const dialog = this.$refs?.editPassengerDialogRef as Vue | undefined;
        const content = dialog?.$refs?.content as HTMLElement | undefined;
        if (!content || !dialog || !dialog.$attrs) return;
        content.setAttribute('aria-label', dialog.$attrs['aria-label']);
        const innerVDialog = content.querySelector('.v-dialog');
        if (innerVDialog) innerVDialog.removeAttribute('tabindex');
        const heading = content.querySelector<HTMLElement>('#main-content');
        if (!heading) return;
        let tries = 0;
        const attempt = () => {
          if (!this.editPassengerDialog) return;
          heading.focus();
          tries++;
          if (document.activeElement !== heading && tries < 30) {
            requestAnimationFrame(attempt);
          }
        };
        requestAnimationFrame(attempt);
      });
    } else {
      this.$store.commit('app/decrementOpenDialogCount');
      window.setTimeout(() => this.dialogOpener?.focus(), 100);
    }
  }

  editPassenger(passenger: IPassenger) {
    // workaround for screen readers to retain focus
    // unfortunate side effect is that we have a zillion dialog instances laying around
    this.editPassengerDialog = true;
    // this.$router.push('/passengers/' + passenger.id);
  }

  get nextTrip() {
    const nextTrip = this.$store.getters["trip/nextTripForPassenger"](
      this.passenger
    );
    if (nextTrip) {
      return nextTrip.startDateTime || nextTrip.endDateTime;
    }
  }
  onClosePassengerDialog(result: { saveSuccess: boolean, saveError: boolean }) {
    this.editPassengerDialog = false;
    this.$emit("editDialogClose", result);
  }

}
